const domains = {};

domains['127.0.0.1'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';
domains.localhost =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';
domains['alexia-dev.constellationagency.com'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';
domains['alexia-stg.constellationagency.com'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/stg/';
domains['alexia-hotfix.constellationagency.com'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/hotfix/';
domains['alexia.constellationagency.com'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/';
domains['lambda-functions'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';
domains['lambda-functions-temp'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';
domains['lambda-lob'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';
domains['lambda-users'] =
  'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/dev/';

domains.environment = 'prd';
domains.assetLibraryAccountId = '1077463629271441'; // for prod

domains.alexiaAppId = '1480296522041789';

domains.CABusinessId = {
  appId: '1069169469786223'
};

domains.featureFlags = {
  localFBCaching: false,
  localFBCachingExpiration: 3600000,
  useNewNavUi: true,
  adPreview: {
    campaignRestructuringEnabled: true
  },
  adLibrary: {
    multiAdLaunchEnabled: true
  }
};

const fbApiDomain = 'graph.facebook.com';
domains.fbVersion = 'v19.0';
domains.fbEndpoint = `https://${fbApiDomain}/${domains.fbVersion}/`;

domains.creds = {
  appId: '1069169469786223'
};

domains.coopRecipientOptions = [
  { key: 0, text: 'Audi', value: 'Audi@acbcoop.com' },
  { key: 1, text: 'Subaru SAF', value: 'saf@ansira.com' },
  { key: 2, text: 'Subaru SDCAP', value: 'SubaruSDC@ansira.com' },
  {
    key: 3,
    text: 'Jaguar',
    value: 'Jaguar'
  },
  {
    key: 4,
    text: 'Land Rover',
    value: 'Land Rover'
  },
  {
    key: 5,
    text: 'VW',
    value: 'VW'
  },
  {
    key: 6,
    text: 'CDJR',
    value: 'CDJR'
  },
  {
    key: 7,
    text: 'Honda',
    value: 'Honda'
  },
  {
    key: 8,
    text: 'Toyota',
    value: 'Toyota'
  }
];

export default domains;

export const getS3Bucket = () => {
  const currentURL = window.location.href;

  switch (true) {
    case currentURL.indexOf('dev') !== -1 ||
      currentURL.indexOf('localhost') !== -1:
      return 'https://s3.amazonaws.com/alexia-assets-dev/assets/';
    case currentURL.indexOf('stg') !== -1:
      return 'https://s3.amazonaws.com/alexia-assets-stg/assets/';
    default:
      return 'https://s3.amazonaws.com/alexia-assets-prd/assets/';
  }
};
export const getGTMIdByDomain = () => {
  const currentURL = window.location.href;

  switch (true) {
    case currentURL.indexOf('dev') !== -1 ||
      currentURL.indexOf('localhost') !== -1:
      return 'GTM-MLR46CN';
    case currentURL.indexOf('stg') !== -1:
      return 'GTM-PHBG8JL';
    default:
      return 'GTM-P8KK4VH';
  }
};

export const AssetBuilderConfig = {
  endpoints: {
    signedUrl: `https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/signed/upload`,
    getListOfJellybeansUrl:
      'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/chromedata/jellybeans?env=prd',
    saveTemplateUrl: `https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/service/ad/templates`,
    editTemplateUrl: `https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/service/ad/templates`,
    getAllTemplatesUrl: `https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/service/ad/templates`,
    downloadChromeImageUrl:
      'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/chromedata/base64',
    postChromedataUrl:
      'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/chromedata/images/vin',
    chromeFieldUrl:
      'https://8g09fgt800.execute-api.us-east-1.amazonaws.com/prod/chromedata/fields'
  },
  s3BucketNames: {
    assetBuilder: 'alexia-assets-prd'
  },
  s3BucketUrls: {
    dev: (directoryPath = 'asset-builder') => {
      return `https://s3.amazonaws.com/alexia-assets-prd/${directoryPath}`;
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/Domains.js